module.exports = __webpack_public_path__ + "static/media/Organization.ca6f795c.svg";